import { render, staticRenderFns } from "./OrganizationLeadKanbanBoard.vue?vue&type=template&id=22afd7ea&"
import script from "./OrganizationLeadKanbanBoard.vue?vue&type=script&lang=js&"
export * from "./OrganizationLeadKanbanBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports